// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--T4xSh","title":"a10a3f92e9--title--U_AAl"};